import { useContext } from 'react';
import { Button, Table, Tag } from 'antd';
import {
    CloudUploadOutlined,
    FileTextOutlined,
} from '@ant-design/icons';

import useCityInvoices from './useCityInvoices';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import ModalInvoiceDetails from './components/ModalInvoiceDetails';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function CityInvoices() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        columns,
        isLoading,
        tableData,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        tableParams,
        totalInvoices,
        activeFilterItems,
        showModalInvoice,
        handleShowModalInvoice,
        invoiceSelected,
        setInvoiceSelected,
        handleClickImportCityInvoice,
    } = useCityInvoices();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<FileTextOutlined />}
                title="Notas Fiscais"
                tag={<Tag color="blue">{poeValorComPontosEmMil(totalInvoices || 0)} cadastradas</Tag>}
                subtitle="Gerencie, visualize e acompanhe todas as notas fiscais importadas no sistema municipal"
                actions={
                    <Button
                        type="primary"
                        icon={<CloudUploadOutlined />}
                        onClick={handleClickImportCityInvoice}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Importar Notas
                    </Button>
                }
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação para ver os detalhes da nota fiscal." />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas fiscais"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1350 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            setInvoiceSelected(record);
                            handleShowModalInvoice();
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalInvoices || 0}
                itemName="notas fiscais"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />

            <ModalInvoiceDetails
                open={showModalInvoice}
                onClose={handleShowModalInvoice}
                invoice={invoiceSelected}
            />
        </div>
    );
}
